<template>
<!-- 支付成功 -->
  <div v-if="bodyShow" class="buying-tickets-succ">
    <!--  -->
    <div class="box">
        <img src="@a/be-myself/2020/success.png" alt="">
        <div class="title">
            购票成功
        </div>
        <div class="text">
            <span v-if="fzr.user_name">负责人：{{fzr.user_name}}</span>
            <span v-if="fzr.user_phone">联系电话：{{fzr.user_phone}}</span>
        </div>
    </div>
    <!--  -->
    <div class="qrcode" v-show="itemObj.product_id==238 || itemObj.product_id==239 || itemObj.product_id==240 || itemObj.product_id==241 || itemObj.product_id==2">
        <div class="title" style="margin-bottom:0;">
            <div class="line"></div>
            <span>校验码(长按识别下方二维码添加)</span>
        </div>
        <div style="text-align: center;width: 100%;font-weight: bold;font-size:40px;color: #ea5f00;line-height:60px;">
          {{order_info.code}}
          <img v-show="itemObj.product_id==238 || itemObj.product_id==2 || itemObj.product_id==235" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode.jpg" alt="">
          <img v-show="itemObj.product_id==239 || itemObj.product_id==2 || itemObj.product_id==235" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr239.png" alt="">
          <img v-show="itemObj.product_id==240" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr240.png" alt="">
          <img v-show="itemObj.product_id==241" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr241.png" alt="">

          <img v-show="itemObj.product_id==242" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr242.png" alt="">
          <img v-show="itemObj.product_id==243" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr243.png" alt="">
          <img v-show="itemObj.product_id==244" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr244.png" alt="">
        </div>
        <p>请牢记您的核验码，并于12月28日13:50之前到达<br/>北京东方艺空间剧场（北京市西城区 天宁1号文化科技创新园内）<br/>凭核验码进行验票入场！</p>
    </div>
    <div class="qrcode" v-show="itemObj.product_id==242 || itemObj.product_id==243 || itemObj.product_id==244|| itemObj.product_id==2">
      <div class="title">
        <div class="line"></div>
        <span>添加小鹿(长按识别下方二维码添加)</span>
      </div>
      <div style="text-align: center;width: 100%;font-weight: bold;font-size:40px;color: #ea5f00;line-height:60px;">
        <img v-show="itemObj.product_id==242|| itemObj.product_id==2" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr242.png" alt="">
        <img v-show="itemObj.product_id==243" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr243.png" alt="">
        <img v-show="itemObj.product_id==244" style="width:120px;height: 120px;" src="https://misc.xjy.cn/zuoziji/qr244.png" alt="">
      </div>
    </div>

    <!-- 订单信息 -->
    <div class="order">
        <div class="title">
            <div class="line"></div>
            <span>订单信息</span>
        </div>
        <div class="content">
            <!-- <div class="row">
                <div class="title-child">订单编号：</div>
                <div class="text">{{item.order_no}}</div>
            </div>
            <div class="row">
                <div class="title-child">下单时间：</div>
                <div class="text">{{item.pay_time}}</div>
            </div> -->
            <div class="row">
                <div class="title-child">商品信息：</div>
                <div class="text">
                    <div>{{itemObj.product_name}}</div>
                    <div><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">{{itemObj.province+' '+itemObj.city+' '+itemObj.district}}</div>
<!--                    <div><img class="img2" src="@a/be-myself/2020/time.png" alt="">12月30日·{{JSON.parse(itemObj.detail||itemObj.product_detail)?JSON.parse(itemObj.product_detail).createTime:''}}</div>-->
<!--                    <div><img class="img2" src="@a/be-myself/2020/time.png" alt="">12月28日·{{JSON.parse(itemObj.product_detail).createTime}}</div>-->

                    <div v-show="itemObj.product_id!=242 && itemObj.product_id!=243 && itemObj.product_id!=244">
                      <img class="img2" src="@a/be-myself/2020/time.png" alt="">做自己节：12月28日·{{JSON.parse(itemObj.product_detail).createTime}}
                    </div>

                    <div v-show="itemObj.product_id==240 || itemObj.product_id==241 || itemObj.product_id==242 || itemObj.product_id==244 || itemObj.product_id==2 || itemObj.product_id==235">
                      <img class="img2" src="@a/be-myself/2020/time.png" alt="">陈海贤工作坊：12月29日·9:00-12:30
                    </div>
                    <div v-show="itemObj.product_id==239 || itemObj.product_id==241 || itemObj.product_id==242 || itemObj.product_id==243 || itemObj.product_id==2 || itemObj.product_id==235">
                      <img class="img2" src="@a/be-myself/2020/time.png" alt="">古典工作坊：12月29日·14:00-17:30
                    </div>

                </div>
            </div>
            <div class="row">
                <div class="title-child">应付金额：</div>
                <div class="text">¥{{price}}</div>
            </div>
            <div class="row">
                <div class="title-child">实付金额：</div>
                <div class="text">¥{{itemObj.price/100}}</div>
            </div>
            <!-- <div class="row">
                <div class="title-child">付款时间：</div>
                <div class="text">2020.10.29 16:24</div>
            </div> -->
        </div>
    </div>
  </div>
</template>

<script>
import { saveInfo,orderGet } from "@/api/be_myself"
import { phoneValidation } from "@u/validation";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            fzr:{},
            order_info:{}
        }
    },
    props:['oid','name','phone','itemObj','price'],
    methods:{
        pullData(){
            if(!this.name || !this.phone || !this.oid || !phoneValidation(this.phone)){
                this.$toast('订单或用户信息不能为空！');
                return
            }
            orderGet({
                id:this.oid
            }).then(data=>{
                if(data.error>0){
                    this.$toast(data.detail);
                    return
                }
                this.fzr = data.item.product_user_list[0];
                this.order_info = data.item;

            });
            this.bodyShow = true;
            shareCon("beMyself", this);
            
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.buying-tickets-succ{
    padding-top: 4px;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .box{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-color: #ffffff;
        padding: 48px 48px 20px;
        img{
            margin-bottom: 24px;
            width: 84px;
            height: 84px;
        }
        .title{
            font-size: 36px;
            color: #333333;
            font-weight: 600;
            line-height: 50px;
            text-align: center;
            margin-bottom: 40px;
        }
        .text{
            display: flex;
            align-items: center;
            font-size: 28px;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
            span{
                &:first-child{
                    margin-right: 40px;
                }
            }
        }
    }
    .qrcode{
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        padding: 24px 24px;
        background-color: #ffffff;
        .title{
            display: flex;
            align-items: center;
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 44px;
            margin-bottom: 40px;
            .line{
                width: 8px;
                height: 20px;
                border-radius: 4px;
                background-color: #FF9800;
                margin-right: 12px;
            }
            span{
                line-height: 1;
            }
        }
        .q{
            display: block;
            margin: 0 auto;
            width: 140px;
            height: 140px;
            margin-bottom: 15px;
        }
        p{
            font-weight: 400;
            color: #606060;
            line-height: 34px;
            text-align: center;
        }
    }
    .order{
        padding: 24px 24px;
        background-color: #ffffff;
        margin-top: 8px;
        flex: 1;
        .title{
            display: flex;
            align-items: center;
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 44px;
            margin-bottom: 40px;
            .line{
                width: 8px;
                height: 20px;
                border-radius: 4px;
                background-color: #FF9800;
                margin-right: 12px;
            }
            span{
                line-height: 1;
            }
        }
        .content{
            padding: 38px 24px 20px;
            border-top: 1px solid #E4E4E4;
            .row{
                display: flex;
                margin-bottom: 24px;
                .title-child{
                    color: #999999;
                    font-size: 28px;
                    margin-right: 16px;
                    width: 140px;
                    line-height: 40px;
                    display: flex;
                    align-self: flex-start;
                }
                .text{
                    color: #606060;
                    flex: 1;
                    font-size: 28px;
                    div{
                        margin-bottom: 12px;
                        line-height: 40px;
                        .img1{
                            width: 30px;
                            height: 28px;
                            margin-right: 8px;
                        }
                        .img2{
                            width: 27px;
                            height: 27px;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>